<div class="not-found-container">
    <div class="error-message">
      <h1>404</h1>
      <p>La pagina che stai cercando non esiste.</p>
      <button type="submit" class=" mt-3 btn btn-primary-ks-white" [routerLink]="['/']"  >
        Torna alla pagina principale
      </button>
    </div>
  </div>